export enum ClaimFilterTypeEnum {
  CLAIM_HANDLING = 'claimHandling',
  CORRESPONDENCE = 'correspondence',
}

export enum ClaimStatusCodeEnum {
  SUBMITTED = 'submitted',
  IN_REVIEW = 'in_review',
  PENDING_APPROVAL = 'pending_approval',
  DOCUMENTS_REQUESTED = 'documents_requested',
  APPROVED = 'approved',
  PENDING_PAYMENT = 'pending_payment',
  CREATE_PAYMENT = 'create_payment',
  PENDING_DOCUMENT = 'pending_document',
  REJECTED = 'rejected',
  REJECTED_ON_PV = 'rejected_on_pv',
  COMPLETED = 'completed',
  CANCELLED = 'cancelled',
  DELETED = 'deleted',
}

export const CLAIM_STATUS_DISPLAY: Record<ClaimStatusCodeEnum, string> = {
  [ClaimStatusCodeEnum.SUBMITTED]: 'รอการพิจารณา',
  [ClaimStatusCodeEnum.IN_REVIEW]: 'อยู่ระหว่างการพิจารณา',
  [ClaimStatusCodeEnum.REJECTED_ON_PV]: 'ปฏิเสธคำขอบน PV เสร็จสิ้น',
  [ClaimStatusCodeEnum.REJECTED]: 'ปฏิเสธคำขอ',
  [ClaimStatusCodeEnum.PENDING_DOCUMENT]: 'ปฏิเสธคำขอ',
  [ClaimStatusCodeEnum.DOCUMENTS_REQUESTED]: 'ขอเอกสารเพิ่มเติม',
  [ClaimStatusCodeEnum.PENDING_APPROVAL]: 'ส่งอนุมัติ',
  [ClaimStatusCodeEnum.PENDING_PAYMENT]: 'อยู่ระหว่างทำเรื่องจ่ายค่าสินไหม',
  [ClaimStatusCodeEnum.CREATE_PAYMENT]: 'ออกใบสั่งจ่าย',
  [ClaimStatusCodeEnum.COMPLETED]: 'ชดเชยค่าสินไหมเสร็จสิ้น',
  [ClaimStatusCodeEnum.APPROVED]: 'อนุมัติ',
  [ClaimStatusCodeEnum.CANCELLED]: 'คำขอถูกยกเลิก',
  [ClaimStatusCodeEnum.DELETED]: 'คำขอถูกลบ',
}

export enum RequestDocumentStatusEnum {
  NOT_USE = 'NOTUSE',
  UPLOADED = 'UPLOADED',
  PENDING = 'PENDING',
  CANCELLED = 'CANCELLED',
}
export enum ReceivedDocumentStatusEnum {
  RECEIVED = 'RECEIVED',
  NOT_RECEIVED = 'NOTRECEIVED',
  NOT_USE = 'NOTUSE',
}

export const REQUEST_DOCUMENT_STATUS_DISPLAY: Record<RequestDocumentStatusEnum, string> = {
  [RequestDocumentStatusEnum.NOT_USE]: 'ไม่มีการขอเอกสารเพิ่มเติม',
  [RequestDocumentStatusEnum.UPLOADED]: 'อัปโหลดเอกสารมาแล้ว',
  [RequestDocumentStatusEnum.PENDING]: 'ยังไม่ได้อัปโหลดเอกสาร',
  [RequestDocumentStatusEnum.CANCELLED]: 'ยกเลิกการขอเอกสาร',
}

export const RECEIVED_DOCUMENT_STATUS_DISPLAY: Record<ReceivedDocumentStatusEnum, string> = {
  [ReceivedDocumentStatusEnum.RECEIVED]: 'ได้รับเอกสารแล้ว',
  [ReceivedDocumentStatusEnum.NOT_RECEIVED]: 'ยังไม่ได้รับเอกสาร',
  [ReceivedDocumentStatusEnum.NOT_USE]: 'ไม่ใช้เอกสารฉบับจริง',
}
